import React from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { usePlatformTranslation } from "@/hooks/usePlatformTranslation";

export interface DownloadButtonProps {
  onClick: () => void;
}

/**
 * Download button component.
 */
export function DownloadButton({ onClick }: DownloadButtonProps) {
  const { t } = usePlatformTranslation();

  return (
    <Button
      variant="ghost"
      size="sm"
      className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted"
      onClick={onClick}
      title={t('platform.common.download')}
    >
      <Download className="h-4 w-4" />
    </Button>
  );
}

export default DownloadButton;

